export enum ToastEnum {
  successToast = 0,
  infoToast = 1,
  warnToast = 2,
  errorToast = 3,
  archiveToast = 4,
  involvingProcessAndPowerAttorneyToast = 5,
  cloudLogisticEvent = 6,
}
